import { FC, useEffect, useRef, useState } from 'react';

import { Button } from '@smartshell/ui-kit';
import cn from 'classnames';
import { Row } from 'react-table';

import { TEventListItem } from 'types';

import { getLogDescription } from '../../utils/getLogDescription';
import s from '../LogMobile.module.scss';
import { IDescriptionProps } from './interfaces';

export const Description: FC<IDescriptionProps> = ({ event }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);
  const descriptionRef = useRef<HTMLDivElement>(null);

  const fakeRow = {
    original: event,
  } as Row<TEventListItem>;

  const content = getLogDescription(fakeRow);

  useEffect(() => {
    if (isExpanded) return;

    const timeout = setTimeout(() => {
      if (descriptionRef.current) {
        const isOverflowing =
          descriptionRef.current.scrollHeight >
          descriptionRef.current.clientHeight;

        setHasOverflow(isOverflowing);
      }
    }, 0);

    return () => clearTimeout(timeout);
  }, [content, isExpanded]);

  return (
    <div className={s.description}>
      {hasOverflow && (
        <Button
          variant="secondary"
          iconName="BottomIcon"
          onlyIcon={true}
          className={cn(s.button, isExpanded && s.expanded)}
          onClick={() => setIsExpanded(!isExpanded)}
        />
      )}
      <div
        ref={descriptionRef}
        className={cn(
          s.description__wrapper,
          isExpanded && s.expanded,
          hasOverflow && s.withButton
        )}
      >
        <div className={s.description_text}>{content}</div>
      </div>
    </div>
  );
};
